import React from 'react';

const Footer = () => {

    return (
        <footer>
            <div className="content">
                <p>
                    &copy; Daniel Martin 2019
                </p>
            </div>
        </footer>
    )
}

export default Footer;